import React from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { client } from '../api';
import type { NotificationRow, NotificationsResponse } from '../api';
import PageContainer from '../components/PageContainer';
import NotificationsTable from '../components/notificationsPage/NotificationsTable';
import { Outlet } from 'react-router-dom';
import { notificationsQueryKey } from '../queries';
import { LoadingSpinner } from 'design-system/src/components/LoadingSpinner/LoadingSpinner';
import { PageLoadError } from 'design-system/src/components/PageLoadError/PageLoadError';

const NotificationsTablePage: React.FC = () => {
  const { data, isLoading, error } = useQuery<NotificationsResponse>({
    queryKey: notificationsQueryKey(),
    queryFn: () =>
      client.get('/portal-notifications').then((res) => {
        res.data.notifications = res.data.notifications.map((item: NotificationRow) => ({
          ...item,
        }));

        return res.data;
      }),
  });

  let body;
  if (isLoading) {
    body = <LoadingSpinner />;
  } else if (error) {
    body = <PageLoadError />;
  } else if (data) {
    body = <NotificationsTable data={data.notifications} />;
  }

  const queryClient = useQueryClient();

  return (
    <>
      <PageContainer
        title="Notifications"
        subtitle="These are updates from Tandem that don't require any action from your team."
      >
        {body}
      </PageContainer>
      <Outlet
        context={{
          reload: () => queryClient.resetQueries({ queryKey: notificationsQueryKey() }),
        }}
      />
    </>
  );
};

export default NotificationsTablePage;
